module.exports = __webpack_public_path__ + "img/webLogoBlanco.07f2715b.svg";